const XIcon = ({ color }: { color?: string }) => (
  <svg
    width="39"
    height="32"
    viewBox="0 0 39 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1395 32C26.6975 32 34.6623 19.6874 34.6623 9.01315C34.6623 8.66701 34.6548 8.31318 34.6397 7.96704C36.1891 6.82345 37.5262 5.40696 38.5882 3.78412C37.1452 4.43936 35.6131 4.86729 34.0443 5.0533C35.6962 4.04275 36.933 2.45522 37.5255 0.585003C35.9715 1.52493 34.2721 2.18797 32.5 2.5457C31.3061 1.2509 29.7274 0.393583 28.0081 0.106307C26.2889 -0.180969 24.5247 0.117793 22.9885 0.956402C21.4523 1.79501 20.2296 3.12676 19.5093 4.74574C18.7891 6.36473 18.6115 8.18078 19.004 9.91312C15.8573 9.75197 12.779 8.91772 9.9686 7.46447C7.15816 6.01122 4.67833 3.97141 2.68987 1.47728C1.67923 3.25564 1.36997 5.36001 1.82495 7.36272C2.27993 9.36543 3.465 11.1162 5.13932 12.2592C3.88234 12.2185 2.6529 11.8731 1.55257 11.2515V11.3515C1.55145 13.2178 2.18361 15.0268 3.3416 16.4712C4.49958 17.9155 6.11193 18.906 7.90456 19.2743C6.74017 19.5995 5.51809 19.6468 4.33289 19.4128C4.83873 21.0178 5.82292 22.4215 7.1481 23.4282C8.47328 24.4348 10.0733 24.9941 11.7249 25.0279C8.921 27.2759 5.4573 28.4951 1.89173 28.4894C1.2594 28.4884 0.6277 28.4488 0 28.3709C3.62224 30.7426 7.83587 32.0023 12.1395 32Z"
      fill={color || "white"}
    />
  </svg>
);

export default XIcon;
